module.exports = __webpack_public_path__ + "img/Group 1000005356.ea3a3ece.png";